import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
} from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { isQuoteIncomplete } from '@boldpenguin/emperor-features';
import { EmperorButtonModule } from '@boldpenguin/emperor-presentational';
import { getPartnerEngineConfig, IQuotesState } from '@boldpenguin/sdk';
import { BpSdkStoreService } from 'src/app/core/services/bp-sdk-store-service/bp-sdk-store.service';
import { quoteRequestSearchUrl } from 'src/app/shared/utilities/debug-link-utilities';

@Component({
  selector: 'app-quotes-debug-tab-item',
  templateUrl: './quotes-debug-tab-item.component.html',
  styleUrls: ['./quotes-debug-tab-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [EmperorButtonModule, MatExpansionModule],
})
export class QuotesDebugTabItemComponent {
  private readonly sdkStoreService = inject(BpSdkStoreService);

  quote = input.required<IQuotesState>();

  quoteLabel = computed(
    () =>
      `${this.quote().carrier?.name || ''} - ${
        this.quote()
          .products?.map((p) => p.name)
          .join(' & ') || ''
      }`,
  );

  carrierEngineUrl = computed(() => {
    const sdkState = this.sdkStoreService.sdkReadyState();
    if (!sdkState) {
      return '';
    }

    const baseUri = getPartnerEngineConfig(sdkState).uri;
    return baseUri && this.quote().online && !isQuoteIncomplete(this.quote())
      ? quoteRequestSearchUrl(baseUri, this.quote())
      : '';
  });
}
